import { darken, lighten } from '@material-ui/core';
import { grey } from '@material-ui/core/colors';
import { blue } from './blue';
import { chartreuse } from './chartreuse';
import { coolGrey } from './coolGrey';
import { green } from './green';
import { navy } from './navy';
import { red } from './red';
import { text } from './text';
import { yellow } from './yellow';

const J1_WHITE = '#fff';
const J1_GREY_LIGHT = '#f2f2f2';
const J1_GREY_MAIN = '#646464';
const J1_GREY_DARK = '#2f2f2f';
const J1_BLACK = '#000';

const J1_MINT_GREEN_LIGHT = '#3ce3b5';
const J1_MINT_GREEN_MAIN = darken(J1_MINT_GREEN_LIGHT, 0.2);
const J1_MINT_GREEN_DARK = darken(J1_MINT_GREEN_LIGHT, 0.4);
const J1_QUERY_ANYWHERE_GREEN = '#54E6B5';

const J1_PURPLE_MAIN = '#362A94';
const J1_PURPLE_LIGHT = '#6647ff';
const J1_PURPLE_DARK = '#01053D';

const J1_YELLOW_MAIN = '#eafca2';
const J1_YELLOW_LIGHT = lighten(J1_YELLOW_MAIN, 0.25);
const J1_YELLOW_DARK = darken(J1_YELLOW_MAIN, 0.25);

const J1_BLUE_LIGHT = '#50b4f9';
const J1_BLUE_MAIN = '#00a6c5';
const J1_BLUE_DARK = darken(J1_BLUE_MAIN, 0.25);
const J1_QUERY_ANYWHERE_BLUE = '#4760E0';

const J1_GRADIENT_LIGHT = `linear-gradient(65deg, ${lighten(
  J1_PURPLE_MAIN,
  0.5
)} 0%, ${lighten(J1_BLUE_MAIN, 0.5)} 33%, ${lighten(
  J1_MINT_GREEN_MAIN,
  0.5
)} 66%, ${lighten(J1_YELLOW_MAIN, 0.5)} 100%)`;
const J1_GRADIENT = `linear-gradient(65deg, ${J1_PURPLE_MAIN} 0%, ${J1_BLUE_MAIN} 33%, ${J1_MINT_GREEN_MAIN} 66%, ${J1_YELLOW_MAIN} 100%)`;
const J1_SECONDARY_GRADIENT = `linear-gradient(180deg, ${J1_PURPLE_LIGHT} 0%, ${J1_PURPLE_MAIN} 50%, ${J1_PURPLE_DARK} 100%)`;
const J1_BACKGROUND_GRADIENT = `linear-gradient(180deg, ${J1_GREY_DARK} 0%, ${J1_BLACK} 100%)`;
const J1_QUERY_ANYWHERE_GRADIENT = `linear-gradient(265.11deg, ${J1_QUERY_ANYWHERE_GREEN} 0%, ${J1_QUERY_ANYWHERE_BLUE} 100%)`;

const J1_DESIGN_TEAM_GRADIENT_V1 = `linear-gradient(265.11deg, #54E6B5 0%, #4760E0 100%)`;

export const palette = {
  primary: {
    light: J1_MINT_GREEN_LIGHT,
    main: J1_MINT_GREEN_MAIN,
    dark: J1_MINT_GREEN_DARK,
    contrastText: grey[50],
  },
  secondary: {
    light: J1_PURPLE_LIGHT,
    main: J1_PURPLE_MAIN,
    dark: J1_PURPLE_DARK,
    contrastText: grey[50],
  },
  tertiary: {
    light: J1_YELLOW_LIGHT,
    main: J1_YELLOW_MAIN,
    dark: J1_YELLOW_DARK,
    contrastText: grey[900],
  },
  quartary: {
    light: J1_BLUE_LIGHT,
    main: J1_BLUE_MAIN,
    dark: J1_BLUE_DARK,
    contrastText: grey[50],
  },
  background: {
    paper: J1_WHITE,
    default: J1_GREY_LIGHT,
    light: J1_GREY_MAIN,
    main: J1_GREY_DARK,
    dark: J1_BLACK,
  },
  gradient: {
    j1Light: J1_GRADIENT_LIGHT,
    j1: J1_GRADIENT,
    secondary: J1_SECONDARY_GRADIENT,
    background: J1_BACKGROUND_GRADIENT,
    j1DesignTeamGradientV1: J1_DESIGN_TEAM_GRADIENT_V1,
    queryAnywhere: J1_QUERY_ANYWHERE_GRADIENT,
  },
  // Legacy colors. Remove these
  blue,
  coolGrey,
  green,
  red,
  text,
  chartreuse,
  yellow,
  navy,
};
